<template>
  <div class="summary-grid">
    <div class="summary-item">
      <h4>{{ totalClicks }}</h4>
      <p>{{ $t('C2W_CAMPAIGNS_REPORT.SUMMARY.TOTAL_CLICKS') }}</p>
    </div>
    <div class="summary-item">
      <h4>{{ uniqueContacts }}</h4>
      <p>{{ $t('C2W_CAMPAIGNS_REPORT.SUMMARY.UNIQUE_CONTACTS') }}</p>
    </div>
    <div class="summary-item">
      <h4>{{ facebookCount }}</h4>
      <p>{{ $t('C2W_CAMPAIGNS_REPORT.SUMMARY.FACEBOOK') }}</p>
    </div>
    <div class="summary-item">
      <h4>{{ instagramCount }}</h4>
      <p>{{ $t('C2W_CAMPAIGNS_REPORT.SUMMARY.INSTAGRAM') }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'C2wCampaignsSummary',
  props: {
    messages: {
      type: Array,
      required: true,
    },
  },
  computed: {
    totalClicks() {
      return this.messages.length;
    },
    uniqueContacts() {
      const uniquePhones = new Set(this.messages.map(m => m.phone_number));
      return uniquePhones.size;
    },
    facebookCount() {
      return this.messages.filter(m => m.source === 'Facebook').length;
    },
    instagramCount() {
      return this.messages.filter(m => m.source === 'Instagram').length;
    },
  },
};
</script>

<style scoped>
.summary-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 20px;
  margin-bottom: 16px;
}

.summary-item {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  text-align: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
}

.summary-item h4 {
  font-size: 20px;
  font-weight: bold;
  margin: 0;
}

.summary-item p {
  margin: 4px 0 0;
  font-size: 14px;
  color: #555;
}
</style>
